import React, { useEffect, useState } from 'react';
import { NewContentForm } from '../../../components/Content/NewContentForm';
import { SmartContainer, Stack } from '../../../styles/Containers';
import { StyledModal } from '../../../styles/matieralui/Modal';
import { StyledA, StyledB, StyledH3, StyledH5, StyledH6, StyledP } from '../../../styles/StyledHTML';
import { StyledLockIcon } from '../../modules/Permission/NoPermissions';

export const EmptyMessage = ({ title = "No results found", children, icon }) => {

    return (
        <SmartContainer flex align="center" justify="center" width="100%" minHeight="70vh">
            <SmartContainer maxWidth="350px" textAlign="center">
                {icon && (
                    <SmartContainer flex align="center" justify="center" width="100%"><StyledLockIcon>{icon}</StyledLockIcon></SmartContainer>
                )}
                <br />
                <StyledH6>{title}</StyledH6>
                <br />
                {children}
            </SmartContainer>
        </SmartContainer>
    )
}